import { useTranslation } from "react-i18next";
import { StalledMessagesDataGridCard } from "../../list/components/stalled-messages-data-grid-card";
import { Direction } from "@bvhi/backend-api/apis";

export const MessagesInfoDetailsCard = () => {
  const { t } = useTranslation(["messages"]);

  return (
    <>
      <StalledMessagesDataGridCard
        direction={Direction.INCOMING}
        subheader={t("messages:incoming.stalled.messages.card.subheader")}
        title={t("messages:incoming.stalled.messages.card.title")}
      />
      <StalledMessagesDataGridCard
        direction={Direction.OUTGOING}
        subheader={t("messages:outgoing.stalled.messages.card.subheader")}
        title={t("messages:outgoing.stalled.messages.card.title")}
      />
    </>
  );
};
